module.exports = __webpack_public_path__ + "img/46_24.67909a65.png";